import {Flex, Text} from '@chakra-ui/react'
import {useTranslation} from 'next-i18next'
import {parseCookies} from 'nookies'
import {useEffect} from 'react'
import {useRecoilValue} from 'recoil'
import Card from '_app/components/Card'
import useAttributesMetadata from '_app/hooks/useAttributesMetadata'
import {GTM_EVENTS, parseProductsToGTM} from '_app/utils/dataLayer'
import {gtmItemListNamesAtom} from '_app/state/atoms'
import {useCheckoutContext} from '../hooks'
import {STEPS} from '../types'
import PaymentMethodForm, {PAYU_PAYMENT_METHODS} from './PaymentMethodForm'

export const PaymentMethodCard = ({ data, clientToken, updateSummary }) => {
  const { t } = useTranslation('checkout')
  const { step, cartCheckoutData } = useCheckoutContext()
  const { cartId } = parseCookies()
  const { metaData } = useAttributesMetadata({})
  const gtmItemListNames = useRecoilValue(gtmItemListNamesAtom)
  useEffect(() => {
    if (!Object.keys(metaData).length || step !== STEPS.PAYMENT) {
      return
    }
    const payload = {
      ecommerce: {
        checkout: {
          actionField: {
            step: 3 as const,
            option:
              cartCheckoutData?.cart?.shipping_addresses[0]
                ?.selected_shipping_method?.carrier_title,
          },
          products: parseProductsToGTM(data, metaData, gtmItemListNames),
          cartId,
        },
      },
    }

    GTM_EVENTS.paymentMethod(payload)
  }, [step])

  const selectedPaymentMethod =
    PAYU_PAYMENT_METHODS.find(
      ppm =>
        ppm.value.payuMethod ===
        cartCheckoutData?.cart?.selected_payment_method?.payu_method
    )?.label || cartCheckoutData?.cart?.selected_payment_method?.title

  return (
    <Card mb={6}>
      <Flex justifyContent="space-between" alignItems="center">
        <Text fontWeight={600}>02. {t('SELECT_PAYMENT_METHOD')}</Text>
      </Flex>
      {step !== STEPS.PAYMENT && selectedPaymentMethod && (
        <Text mt={2} ml={7}>
          {selectedPaymentMethod}
        </Text>
      )}
      {step === STEPS.PAYMENT && <PaymentMethodForm clientToken={clientToken} data={data} updateSummary={updateSummary} />}
    </Card>
  )
}
